export default __webpack_public_path__ + "static/media/springboot.b39d866e.svg";